import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Menu as MenuIcon } from '@mui/icons-material';
import { Box, ButtonBase, Typography, useMediaQuery } from '@mui/material';

import { Avatar } from '@/ui/Avatar';

import Devices from './Devices';
import LinkedAccounts from './LinkedAccounts';
import ManagePassword from './ManagePassword';
import Menu from './Menu';
import ProfileForm from './ProfileForm';
import { useProfile } from './ProfileProvider';
import { routeConfig } from './routeConfig';
import { Template } from './ui/Template';
import { desktopMediaQuery } from './utils/mediaQuery';
import { useHashRouting } from './utils/useHashRouting';

const paperStyle = {
  borderRadius: 3,
  background: 'white',
  padding: { xs: 2, md: 3, xl: 4 },
};

export default function UserAccount() {
  const { t } = useTranslation('menu');
  const { currentHash } = useHashRouting();
  const isDesktop = useMediaQuery(desktopMediaQuery);

  const [drawerOpen, setDrawerOpen] = useState(isDesktop);
  const { profile } = useProfile();

  const renderPage = () => {
    switch (currentHash) {
      case routeConfig.profile:
        return <ProfileForm isDesktop={isDesktop} />;
      case routeConfig.password:
        return <ManagePassword />;
      case routeConfig.activeSessions:
        return <Devices />;
      case routeConfig.linkAccount:
        return <LinkedAccounts />;
      default:
        return <ProfileForm isDesktop={isDesktop} />;
    }
  };

  return (
    <Template>
      <Menu
        isDesktop={isDesktop}
        isDrawerOpen={drawerOpen}
        onDrawerOpen={setDrawerOpen}
      />
      {!isDesktop && (
        <ButtonBase
          sx={{
            ...paperStyle,
            display: 'flex',
            gap: '12px',
            padding: '8px 16px',
            alignItems: 'center',
            justifyContent: 'start',
            textAlign: 'start',
          }}
          onClick={() => setDrawerOpen(true)}
        >
          <Avatar size="medium" />
          <Box>
            <Typography
              sx={{
                fontWeight: (theme) => theme.typography.fontWeightBold,
              }}
              variant="subtitle1"
            >
              {t('welcome')}
            </Typography>
            <Typography
              fontSize={14}
              color="secondary"
              sx={{
                maxWidth: '60vw',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {profile?.email}
            </Typography>
          </Box>
          <MenuIcon sx={{ marginLeft: 'auto' }} />
        </ButtonBase>
      )}
      <Box
        component="main"
        sx={{
          ...paperStyle,
          width: isDesktop ? '100%' : 'initial',
          position: 'relative',
          minHeight: '670px',
        }}
      >
        {renderPage()}
      </Box>
    </Template>
  );
}
